export default __webpack_public_path__ + "static/media/MusicIcon.c0166aa8.svg";